import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useKlaviyoSyncStatusQuery = createQueryHook(
  CreatorIntegrationsApiClient.getKlaviyoSyncStatus,
  {
    queryKey: ['klaviyoSyncStatus'],
  },
)
